import axios from "@/api/axios";

function getPayments() {
  return axios.get("services/v1.0/payments/");
}

function getAccruals() {
  return axios.get("services/v1.0/accruals/");
}
export default {
  getPayments,
  getAccruals
};
